// extracted by mini-css-extract-plugin
export default {"root":"InfoCircle_root__qf50v","exclamation":"InfoCircle_exclamation__0TlUf","question":"InfoCircle_question__w-x1R"};